import React, { useState } from 'react';
import Button from './ui/Button';
import Card from './ui/Card';
import './Login.css';

const Login = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setLoading(true);
    try {
      await onLogin();
    } catch (error) {
      console.error('Login failed:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      {/* Minimal Background */}
      <div className="login-background">
        <div className="bg-gradient"></div>
      </div>

      {/* Centered Login Card */}
      <div className="login-content">
        <div className="login-center">
          <Card variant="elevated" className="login-card" padding="xl">
            {/* Minimal Branding */}
            <div className="login-branding-minimal">
              <div className="logo-container-minimal">
                <img 
                  src="/selkirk-logo.png" 
                  alt="Selkirk Copper" 
                  className="logo-minimal"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="logo-fallback-minimal" style={{ display: 'none' }}>
                  <span>SC</span>
                </div>
              </div>
              <h1 className="company-name">Selkirk Copper</h1>
            </div>

            {/* Authentication Section */}
            <div className="auth-section">
              <h2>Sign In</h2>
              <p>Access your account to continue</p>

              <div className="auth-provider">
                <Button
                  variant="primary"
                  size="lg"
                  fullWidth
                  loading={loading}
                  onClick={handleLogin}
                  className="login-button"
                  icon={
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M11.4 24H0V12.6H11.4V24Z" fill="#F25022"/>
                      <path d="M24 24H12.6V12.6H24V24Z" fill="#00A4EF"/>
                      <path d="M11.4 11.4H0V0H11.4V11.4Z" fill="#7FBA00"/>
                      <path d="M24 11.4H12.6V0H24V11.4Z" fill="#FFB900"/>
                    </svg>
                  }
                >
                  {loading ? 'Signing In...' : 'Sign In with Microsoft'}
                </Button>
              </div>

              {/* Minimal Help */}
              <div className="login-help-minimal">
                <a 
                  href="mailto:tech@selkirkcopper.com?subject=Login Support Request" 
                  className="help-link-minimal"
                >
                  Need help? Contact IT Support
                </a>
              </div>
            </div>
          </Card>

          {/* Minimal Status */}
          <div className="status-minimal">
            <div className="status-item">
              <div className="status-dot online"></div>
              <span>Secure connection</span>
            </div>
          </div>
        </div>
      </div>

      {/* Minimal Footer */}
      <div className="login-footer-minimal">
        <p>&copy; {new Date().getFullYear()} Selkirk Copper Mines</p>
      </div>
    </div>
  );
};

export default Login;

